<div class="header bg-primary">
  <div fxLayout="row wrap" fxLayoutAlign="space-between center">
    <h2 class="fw-500 secondary-font">Order {{order.id}}</h2>
    <app-dialog-header-controls [dialogRef]="dialogRef"></app-dialog-header-controls>
  </div>
</div>
<mat-dialog-content>
  <mat-dialog-content>
    <div class="pt-3">
      <div fxLayout="row wrap" class="flex-wrapper">

        <div fxFlex="100" class="px-3 mb-2">
          <h2 class="secondary-font">Shopping Cart</h2>
        </div>

        <!-- <div fxFlex="100" class="px-3 mb-5">
          <div class="divider"></div>
          <div class="mat-table theme-table review-order-table">
            <div class="mat-header-row">
              <div class="mat-header-cell image">Image</div>
              <div class="mat-header-cell">Name</div>
              <div class="mat-header-cell price">Unit Price</div>
              <div class="mat-header-cell quantity">Quantity</div>
              <div class="mat-header-cell total">Total</div>
            </div>
          </div>
        </div> -->

        <table
          style="padding: 0px 0px; margin: 0px 0px; background: transparent; width:100%;vertical-align: top; height: 100%; ">

          <tr *ngFor="let  orderLine of order.orderLines let j = index">

            <td>
              <div class="mat-cell image">
                <img style="height:60px; width: 60px" [src]="orderLine.image.small || '../assets/starterImage.png'" />
              </div>
            </td>
            <td style="vertical-align: top; width: 10%; background-color: transparent;">
              <mat-icon *ngIf="orderLine.status === 'ClosedB' && order.status ==='open'"
                matTooltip="Item has been created.">check_circle</mat-icon>
              <mat-icon *ngIf="orderLine.status === 'ClosedB' && order.status ==='Service'"
                matTooltip="Item has been created.">check_circle</mat-icon>
              <mat-icon *ngIf="orderLine.status === 'ClosedK' && order.status ==='Service'"
                matTooltip="Item has been created.">check_circle</mat-icon>
              <mat-icon *ngIf="orderLine.status === 'ClosedB' && order.status ==='Closed'"
                matTooltip="Item has been fulfilled.">done_all</mat-icon>
              <mat-icon *ngIf="orderLine.status === 'ClosedK' && order.status ==='Closed'"
                matTooltip="Item has been fulfilled.">done_all</mat-icon>
              <mat-icon *ngIf="orderLine.status !== 'ClosedB' && orderLine.status !== 'ClosedK'"
                matTooltip="Item is pending.">pending</mat-icon>

            </td>
            <td style="vertical-align: top; width: 70%; background-color: transparent">
              {{orderLine.heading.toUpperCase()}}
            </td>
            <td style="vertical-align: top; width: 10%; background-color: transparent">
              <div>{{orderLine.quantity}}</div>
            </td>
            <td style="vertical-align: top; width: 10%; background-color: transparent">
              <div>{{orderLine.cost | currency:currency:symbol:'1.2-2'}}{{euro}}</div>
            </td>
            <td style="vertical-align: top; width: 10%; background-color: transparent;">
              <div>{{(orderLine.cost *orderLine.quantity) | currency:currency:symbol:'1.2-2'}}{{euro}}</div>
            </td>


          </tr>
          <tr>
            <td colspan="6" style="text-align: right;">
              <hr>
              Total:&nbsp;
              <span>{{orderTotals | currency:currency:symbol:'1.2-2'}}{{euro}}</span>
            </td>
          </tr>
          <tr *ngIf="order.discount > 0" >
            <td colspan="6" style="text-align: right;">
              Discount:&nbsp;
              <span>{{order.discount}}%</span>
            </td>
          </tr>
          <tr *ngIf="(order.deliveryCost > 0)">
            <td colspan="6" style="text-align: right;">
              Delivery:&nbsp;
              <span>{{order.deliveryCost | currency:currency:symbol:'1.2-2'}}{{euro}}</span>
            </td>
          </tr>
          <tr>
            <td colspan="6" style="text-align: right;">
              Grand total:&nbsp;
              <span>{{(orderTotals - (order.discount/100)) + order.deliveryCost | currency:currency:symbol:'1.2-2'}}{{euro}}</span>
            </td>
          </tr>
        </table>
      </div>

      <div fxLayout="row wrap" class="flex-wrapper">
        <div fxFlex="100" class="px-3 mb-2">
          <h2 class="secondary-font">Delivery Address</h2>
        </div>
        <div fxFlex="100" class="px-3 mb-2">
          <div class="divider"></div>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
          <p class="text-muted mb-1">Name:</p>
          <p>{{deliveryAddress.firstName}} {{deliveryAddress.lastName}}</p>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
          <p class="text-muted mb-1">Email:</p>
          <p>{{deliveryAddress.email}}</p>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
          <p class="text-muted mb-1">Phone:</p>
          <p>{{deliveryAddress.phone}}</p>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
          <p class="text-muted mb-1">Country:</p>
          <p>{{deliveryAddress.country}}</p>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
          <p class="text-muted mb-1">City:</p>
          <p>{{deliveryAddress.city}}</p>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
          <p class="text-muted mb-1">Place:</p>
          <p>{{deliveryAddress.place}}</p>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
          <p class="text-muted mb-1">Zip/PostalCode:</p>
          <p>{{deliveryAddress.postCode}}</p>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="25" class="px-3">
          <p class="text-muted mb-1">Address:</p>
          <p>{{deliveryAddress.address}}</p>
        </div>
      </div>

      <!-- <div fxLayout="row wrap" class="flex-wrapper">
        <div fxFlex="100" class="px-3 mb-2 mt-3">
          <h2 class="secondary-font">Delivery Method</h2>
        </div>
        <div fxFlex="100" class="px-3">
          <div class="divider"></div>
        </div>
      </div> -->

      <!-- <div fxLayout="row wrap" class="flex-wrapper">
        <div fxFlex="100" class="px-3 mb-2 mt-3">
          <h2 class="secondary-font">Payment Method</h2>
        </div>
        <div fxFlex="100" class="px-3">
          <div class="divider"></div>
        </div>
      </div> -->

    </div>

  </mat-dialog-content>